import * as Yup from 'yup';
import {t} from 'ttag';

export const invoiceSearchValidationSchema = Yup.object().shape({
  ticketNumber: Yup.string().when('$searchInvoice', (searchInvoice, schema) => {
    if (!searchInvoice[0])
      return schema
        .matches(
          /^(331|737)-\d{10}$/,
          t`Ticket or EMD Number must be in the valid format 331-0123456789 or 737-0123456789`
        )
        .required(t`Ticket or EMD Number is required`);
    else return schema.nullable().transform(() => null);
  }),
  invoiceNumber: Yup.string().when('$searchInvoice', (searchInvoice, schema) => {
    if (searchInvoice[0])
      return schema
        .matches(/^\d{4}\/\d{10}$/, t`Invoice Number must be in the valid format YYYY/0123456789`)
        .required(t`Invoice Number is required`);
    else return schema.nullable().transform(() => null);
  })
});
